import React from 'react';
import { ZapIcon } from 'lucide-react';
export function Footer() {
  const footerLinks = {
    platform: [{
      label: 'Features',
      href: '#features'
    }, {
      label: 'Pricing',
      href: '#pricing'
    }, {
      label: 'Jersey Builder',
      href: '#'
    }, {
      label: 'Brackets',
      href: '#brackets'
    }],
    community: [{
      label: 'Discord',
      href: '#'
    }, {
      label: 'Twitter/X',
      href: '#'
    }, {
      label: 'Tournaments',
      href: '#'
    }, {
      label: 'Blog',
      href: '#'
    }],
    legal: [{
      label: 'Terms of Service',
      href: '#'
    }, {
      label: 'Privacy Policy',
      href: '#'
    }, {
      label: 'Cookie Policy',
      href: '#'
    }]
  };
  return <footer className="relative bg-gray-950 border-t border-cyan-500/20" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12" data-id="element-11">
          {/* Logo & Description */}
          <div className="lg:col-span-2" data-id="element-12">
            <a href="#" className="flex items-center gap-2 mb-4" data-id="element-13">
              <div className="w-8 h-8 bg-gradient-to-br from-cyan-400 to-cyan-600 rounded clip-corner-br flex items-center justify-center" data-id="element-14">
                <ZapIcon className="w-5 h-5 text-gray-950" data-id="element-15" />
              </div>
              <span className="font-display font-bold text-xl tracking-wider text-white" data-id="element-16">
                CLAN<span className="text-cyan-400" data-id="element-17">ARENA</span>
              </span>
            </a>
            <p className="text-gray-500 mb-6 max-w-sm" data-id="element-18">
              The all-in-one operations hub for esports organizations. Build
              rosters, design jerseys, run tournaments.
            </p>
            <p className="text-sm text-gray-600" data-id="element-19">Limassol, Cyprus</p>
          </div>

          {/* Platform Links */}
          <div data-id="element-20">
            <h4 className="font-display font-bold text-sm text-white uppercase tracking-wider mb-4" data-id="element-21">
              Platform
            </h4>
            <ul className="space-y-3" data-id="element-22">
              {footerLinks.platform.map(link => <li key={link.label} data-id="element-23">
                  <a href={link.href} className="text-gray-500 hover:text-cyan-400 transition-colors text-sm" data-id="element-24">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Community Links */}
          <div data-id="element-25">
            <h4 className="font-display font-bold text-sm text-white uppercase tracking-wider mb-4" data-id="element-26">
              Community
            </h4>
            <ul className="space-y-3" data-id="element-27">
              {footerLinks.community.map(link => <li key={link.label} data-id="element-28">
                  <a href={link.href} className="text-gray-500 hover:text-cyan-400 transition-colors text-sm" data-id="element-29">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-30">
            <h4 className="font-display font-bold text-sm text-white uppercase tracking-wider mb-4" data-id="element-31">
              Legal
            </h4>
            <ul className="space-y-3" data-id="element-32">
              {footerLinks.legal.map(link => <li key={link.label} data-id="element-33">
                  <a href={link.href} className="text-gray-500 hover:text-cyan-400 transition-colors text-sm" data-id="element-34">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800" data-id="element-35">
          <p className="text-center text-sm text-gray-600" data-id="element-36">
            © 2026 Clanarena. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}